import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';

const PrivacyPolicyPage = () => {
  useEffect(() => {
    document.title = 'Privacy Policy - Tanzania Basketball Federation';
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <header className="w-full py-6 px-4 lg:px-6 border-b border-border bg-card">
        <div className="max-w-3xl mx-auto flex items-center justify-between gap-4">
          <div className="flex items-center space-x-3">
            <div className="flex items-center justify-center w-10 h-10 bg-primary rounded-lg">
              <Icon name="Shield" size={20} color="white" />
            </div>
            <div>
              <h1 className="text-lg font-bold text-foreground">Privacy Policy</h1>
              <p className="text-xs text-muted-foreground">Tanzania Basketball Federation</p>
            </div>
          </div>
          <Button variant="ghost" size="sm" iconName="ArrowLeft" asChild>
            <Link to="/login">Back to Login</Link>
          </Button>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 py-10 space-y-6">
        <div className="bg-card rounded-lg border border-border card-shadow p-6 md:p-8 space-y-5">
          <p className="text-sm text-muted-foreground">
            Last updated: {new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}
          </p>

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-foreground">Your Responsibility for Data Privacy</h2>
            <p className="text-foreground leading-relaxed">
              Data privacy is the responsibility of every user who manages personal or organisational
              data within the Tanzania Basketball Federation (TBF) Registration System. By accessing
              and using this system, you agree to handle all information carefully, lawfully, and in
              accordance with the Personal Data Protection Act of the United Republic of Tanzania
              and any related regulations issued by competent authorities.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-lg font-semibold text-foreground">User Obligations</h2>
            <ul className="list-disc pl-5 space-y-2 text-foreground">
              <li>
                Collect, store, update, and share only data that is necessary for legitimate
                basketball administration and development activities.
              </li>
              <li>
                Protect login credentials and prevent unauthorised access to records under your care.
              </li>
              <li>
                Ensure that personal data entered into the system is accurate, complete, and kept
                up to date.
              </li>
              <li>
                Refrain from disclosing personal information to third parties except where authorised
                by TBF policy or required by law.
              </li>
              <li>
                Report suspected data breaches, misuse, or unauthorised access without delay.
              </li>
            </ul>
          </section>

          <section className="space-y-3">
            <h2 className="text-lg font-semibold text-foreground">Purpose of Processing</h2>
            <p className="text-foreground leading-relaxed">
              Personal and organisational data processed through this system is intended solely to
              support registration, competition management, and related administrative functions of
              basketball in Tanzania under the oversight of the Tanzania Basketball Federation.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-lg font-semibold text-foreground">Compliance</h2>
            <p className="text-foreground leading-relaxed">
              Users must comply with the Personal Data Protection Act and TBF internal policies when
              managing data. Failure to uphold these responsibilities may result in restricted
              access, disciplinary measures, or referral to relevant authorities where applicable.
            </p>
          </section>
        </div>
      </main>

      <footer className="w-full py-6 px-4 border-t border-border">
        <p className="text-center text-sm text-muted-foreground">
          © {new Date().getFullYear()} Tanzania Basketball Federation. All rights reserved.
        </p>
      </footer>
    </div>
  );
};

export default PrivacyPolicyPage;
